"use client";

import { splitLinks } from "@/lib/assistant-format";

export default function LinkifiedText({ text }: { text: string }) {
  const segments = splitLinks(text);
  return (
    <>
      {segments.map((seg, i) =>
        seg.type === "url" ? (
          <a
            key={i}
            href={seg.value}
            target="_blank"
            rel="noopener noreferrer"
            className="text-emerald-300 underline decoration-emerald-300/40 hover:decoration-emerald-300"
          >
            {seg.value}
          </a>
        ) : (
          <span key={i}>{seg.value}</span>
        )
      )}
    </>
  );
}
